/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type RenderDeliveryNotePreviewPartial = typeof RenderDeliveryNotePreviewPartial[keyof typeof RenderDeliveryNotePreviewPartial];


export const RenderDeliveryNotePreviewPartial = {
  true: 'true',
  false: 'false',
} as const;
